import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-no-gts-data-box',
  templateUrl: './no-gts-data-box.component.html',
  styleUrls: ['./no-gts-data-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoGtsDataBoxComponent {}
